import { render, staticRenderFns } from "./StepOptional.vue?vue&type=template&id=49b5f812&"
import script from "./StepOptional.vue?vue&type=script&lang=js&"
export * from "./StepOptional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports